import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'frontbucket.dashboard.overview.pullRequest.commentIcon.label',
    description: 'The number of comments on a pull request.',
    defaultMessage:
      '{commentCount, plural, one {{commentCount} comment} other {{commentCount} comments}}',
  },
  unseenActivityLabel: {
    id: 'frontbucket.dashboard.overview.pullRequest.commentIcon.unseenActivityLabel',
    description: 'Label for the comment icon if there is unseen activity.',
    defaultMessage: 'Unseen activity',
  },
});
